export const FILTER_TYPE = {
    ASYNC_SELECT: 'asyncselect',
    DATE_PICKER: 'datepicker',
    DROPDOWN: 'dropdown',
    CHECKBOX: 'checkbox',
    INPUT: 'input',
    RADIO: 'radio',
    TOGGLE: 'toggle',
    TOOLTIP: 'tooltip',
    TWO_STAGE: 'twostage',
    TYPE_AHEAD: 'typeahead',
};

export const TOOLTIP_FILTER_ALL_BADGE = {
    LABEL_TEXT: 'All',
};

export const TYPE_AHEAD_FILTER = {
    NO_RESULTS_FOUND: 'No Results Found',
    LOADING: 'Loading...',
};
